import { matchesAcCircuitProfileDefinition } from "./catalog/ac-circuits";
import { getStateOption } from "./simulate/states";
import type { ComponentDefinition } from "./types";

export function hasAcPanelControls(def: ComponentDefinition): boolean {
  return ["dist-ac-panel-120", "dist-ac-panel-230"].includes(def.id) && matchesAcCircuitProfileDefinition(def);
}

export function acPanelContacts(def: ComponentDefinition, state?: string): { main: boolean | undefined; branches: Array<boolean | undefined> } {
  const option = getStateOption(def, state);
  if (!option) return { main: undefined, branches: [undefined, undefined, undefined] };
  const main = !option.id.startsWith("main-off");
  const branchOption = main ? option : getStateOption(def, state?.startsWith("main-off:") ? state.slice("main-off:".length) : "all-on");
  return {
    main,
    branches: [1, 2, 3].map(branch => branchOption?.intraLinks?.some(([a, b]) =>
      (a === "ac-in-l" && b === `ac-branch${branch}-l`) || (b === "ac-in-l" && a === `ac-branch${branch}-l`)) ?? false),
  };
}

export function toggleAcPanelMain(def: ComponentDefinition, state?: string): string {
  if (acPanelContacts(def, state).main == null) return "all-on";
  if (!acPanelContacts(def, state).main) return state?.startsWith("main-off:") ? state.slice("main-off:".length) : "all-on";
  return `main-off:${state ?? "all-on"}`;
}

/** Existing combination IDs remain valid. The backward-compatible main-off:
 * extension remembers the branch combination while the main is open. */
export function toggleAcPanelBranch(def: ComponentDefinition, state: string | undefined, branch: number): string {
  const contacts = acPanelContacts(def, state);
  if (!contacts.main || branch < 1 || branch > 3) return state ?? "all-on";
  const enabled = contacts.branches.map((on, i) => i === branch - 1 ? !on : on)
    .flatMap((on, i) => on ? [i + 1] : []);
  if (enabled.length === 3) return "all-on";
  if (!enabled.length) return "branches-off";
  return `${enabled.length === 1 ? "branch" : "branches"}-${enabled.join("-")}`;
}
